import { useState, useContext, useEffect} from "react";
import { StyleContext } from "../providers/StyleContextProvider";
import { Button } from "../components/Shared/Buttons/Button";
import { useMediaQuery } from 'react-responsive';
import { FAQs } from "../components/HelpAndSupport/FAQs";
import { ContactUs } from "../components/HelpAndSupport/ContactUs";
import { AuthContext } from '../providers/AuthContextProvider';
import { LoggedRecruiter } from '../models/LoggedRecruiter';
import { RecruiterMenu } from "../components/Shared/RecruiterMenu";
import { Footer } from "../components/Shared/Footer";
import { createSearchParams, useNavigate, useParams, useLocation } from 'react-router-dom';
import { ProfileEntrance } from "../components/Home/ProfileEntrance";
import { ReactComponent as Search } from '../assets/svg/search.svg';
import { ReactComponent as Plus } from '../assets/svg/plus.svg';

export const HelpAndSupportPage : React.FC = () => {
    const navigate = useNavigate();
    let params = useParams();
    const location = useLocation();
    const styleContext = useContext(StyleContext);
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter = authContext.getLoggedRecruiter();
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("helpAndSupportPage"));
    const tab = params.tab;
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const [searchTerm, setSearchTerm] = useState<string>("");

    useEffect(() => {                    
        if(recruiter === null) {  
            const params = { callbackUrl: location.pathname + location.search, message: "Please login or register to view the Help and Support page." };
            navigate({
                pathname: '/recruiter/account/login',
                search: `?${createSearchParams(params)}`
            });
        } 
    }, []);

    useEffect(() => {         
        setStyles(styleContext.getComponentStyle("helpAndSupportPage"));
    }, [isMobile]);

    const handleButtonClick = (tab: string) => {
        navigate(`/recruiter/helpAndSupport/${tab}`);
    };

    const toVacancyPosting = () => {
        navigate(`/recruiter/vacancy/addedit?orgId=${0}`);
    }
    
    return(
        <>
            <div style={styles.baseWrapper}>
                <div style={styles.leftWrapper}>
                    <RecruiterMenu >
                        <Button style={styles.newJob} onClick={toVacancyPosting}>
                            {"Create a New Job"}
                            <span style={styles.newJob.iconWrapper}><Plus style={styles.newJob.icon}/></span>
                        </Button>
                    </RecruiterMenu>
                </div>
                <div style={styles.rightWrapper}>
                    <div style={styles.header}> 
                        <div style={styles.searchWrapper}>
                            <div style={styles.searchBar}>
                                <input style={styles.searchBar.input} placeholder={"Search"} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
                                <Search style={styles.searchBar.icon}/>
                            </div>
                            <div style={styles.profileWrapper}><ProfileEntrance recruiter={recruiter} /></div>
                        </div>   
                    </div>
                    <div style={styles.title}>Help & Support</div>
                    <div style={styles.tabs}>
                        <Button type="button" style={{ ...styles.tab, ...(tab === "FAQs" && styles.tab.active)}} onClick={()=> handleButtonClick("FAQs")}>{"FAQs"}</Button>
                        <Button type="button" style={{ ...styles.tab,...(tab === "ContactUs" && styles.tab.active)}} onClick={()=> handleButtonClick("ContactUs")}>{"Contact Us"}</Button>
                    </div>
                    {tab === "FAQs" && <FAQs styles={styles.FAQs}/>}
                    {tab === "ContactUs" && <ContactUs recruiter={recruiter} styles={styles.contactUs}/>}
                </div>
            </div>
            <Footer />
        </>
    )
}